export function formatDate(date: Date) {
  return new Intl.DateTimeFormat('fr-FR', {
    dateStyle: 'medium',
  }).format(date)
}

/**
 * Date & heure courtes ("16/08/2026 08:05") depuis une chaîne ISO locale
 * (sans fuseau, telle que renvoyée par l'API). Retourne undefined si invalide.
 */
export function formatDateTime(iso?: string): string | undefined {
  if (!iso)
    return undefined
  const date = new Date(iso)
  if (Number.isNaN(date.getTime()))
    return undefined
  return new Intl.DateTimeFormat('fr-FR', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(date)
}
